import { MouseEventHandler, useState } from "react";
import { ButtonPropsType } from "./type.ts";
import LoaderComponent from "../loader/LoaderComponent.tsx";
import { categoryClass, sizeClass } from "./constants.ts";
import { twMerge } from "tailwind-merge";

const Button = ({
  className = "",
  children,
  type = "button",
  variant = "primary",
  icon = false,
  size = "base",
  tooltipContent = false,
  loading,
  filled = true,
  onClick,
  ...props
}: ButtonPropsType) => {
  const [load, setLoad] = useState(loading ?? false);

  const handleClick = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (!onClick) return;
    setLoad(true);
    await onClick(e);
    setLoad(false);
  };

  return (
    <button
      data-tooltip-id={tooltipContent ? "common-tooltip" : undefined}
      data-tooltip-html={tooltipContent ? tooltipContent : undefined}
      className={twMerge(
        `group/button relative inline-flex h-auto w-auto cursor-pointer items-center justify-center rounded-md border border-transparent shadow-sm hover:shadow focus-visible:outline focus-visible:outline-2 focus-visible:outline-app-500 focus-visible:ring-0 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 ${sizeClass[size]} ${categoryClass[variant]} transition-all duration-300 ease-in-out`,
        !filled ? "bg-transparent py-0 shadow-none border-transparent" : "",
        className
      )}
      onClick={handleClick as MouseEventHandler<HTMLButtonElement>}
      {...props}
    >
      {load ? <LoaderComponent /> : !!icon ? icon : null}
      {children}
    </button>
  );
};

export default Button;
